/**
 * Created by lihanying on 2017/7/5.
 */
import { GETCLUBLIST } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBLIST:
      return Object.assign({}, state, { clubList: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/Home/reduce.js